module.exports = __webpack_public_path__ + "img/ic_nav_sound-off.a95320ba.svg";